unit View.Recebimentos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewRecebimentosList = class(TForm)
    btNew: TButton;
    RecebimentosDataset: TXDataWebDataSet;
    RecebimentosDatasetid: TIntegerField;
    RecebimentosDatasetaliado_id: TIntegerField;
    RecebimentosDatasetdata_base_id: TIntegerField;
    RecebimentosDatasetareceber_id: TIntegerField;
    RecebimentosDatasetvalor_bruto_recebido: TFloatField;
    RecebimentosDatasetvalor_desconto: TFloatField;
    RecebimentosDatasetvalor_multa: TFloatField;
    RecebimentosDatasetvalor_juros: TFloatField;
    RecebimentosDatasetvalor_outros: TFloatField;
    RecebimentosDatasetdata_recebimento: TDateTimeField;
    RecebimentosDatasetplano_contas_id: TIntegerField;
    RecebimentosDatasetconta_id: TIntegerField;
    RecebimentosDatasetmodalidade_id: TIntegerField;
    RecebimentosDatasetfuncionario_id: TIntegerField;
    RecebimentosDatasettitulo_cobranca_id: TIntegerField;
    RecebimentosDatasetrecebimento_via_banco: TBooleanField;
    RecebimentosDatasetrecebimento_venda_aprazo: TBooleanField;
    RecebimentosDatasetcodigo_interno: TIntegerField;
    RecebimentosDatasetexcluido: TBooleanField;
    RecebimentosDatasetinclusao: TDateTimeField;
    RecebimentosDatasetalteracao: TDateTimeField;
    RecebimentosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewRecebimentosList: TFViewRecebimentosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRecebimentosList }

procedure TFViewRecebimentosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewRecebimentosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRecebimentosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewRecebimentosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewRecebimentosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewRecebimentosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewRecebimentosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      RecebimentosDataset.Connection.Model.DefaultSchema.FindEntityType(RecebimentosDataset.EntitySetName),
      RecebimentosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewRecebimentosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('recebimentos', 'active');
  TUtils.SetValorDicionarioClasses('recebimentos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_recebimentos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    RecebimentosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewRecebimentosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.recebimentos.list.pagination.info');
  btNew := TButton.Create('view.recebimentos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.recebimentos.list.table');
  cbPageSize := TComboBox.Create('view.recebimentos.list.cbPageSize');
  edSearch := TEdit.Create('view.recebimentos.list.search');
  lcPaginator := TListControl.Create('view.recebimentos.list.pagination');
  RecebimentosDataset := TXDataWebDataSet.Create(Self);
  RecebimentosDatasetid := TIntegerField.Create(Self);
  RecebimentosDatasetaliado_id := TIntegerField.Create(Self);
  RecebimentosDatasetdata_base_id := TIntegerField.Create(Self);
  RecebimentosDatasetareceber_id := TIntegerField.Create(Self);
  RecebimentosDatasetvalor_bruto_recebido := TFloatField.Create(Self);
  RecebimentosDatasetvalor_desconto := TFloatField.Create(Self);
  RecebimentosDatasetvalor_multa := TFloatField.Create(Self);
  RecebimentosDatasetvalor_juros := TFloatField.Create(Self);
  RecebimentosDatasetvalor_outros := TFloatField.Create(Self);
  RecebimentosDatasetdata_recebimento := TDateTimeField.Create(Self);
  RecebimentosDatasetplano_contas_id := TIntegerField.Create(Self);
  RecebimentosDatasetconta_id := TIntegerField.Create(Self);
  RecebimentosDatasetmodalidade_id := TIntegerField.Create(Self);
  RecebimentosDatasetfuncionario_id := TIntegerField.Create(Self);
  RecebimentosDatasettitulo_cobranca_id := TIntegerField.Create(Self);
  RecebimentosDatasetrecebimento_via_banco := TBooleanField.Create(Self);
  RecebimentosDatasetrecebimento_venda_aprazo := TBooleanField.Create(Self);
  RecebimentosDatasetcodigo_interno := TIntegerField.Create(Self);
  RecebimentosDatasetexcluido := TBooleanField.Create(Self);
  RecebimentosDatasetinclusao := TDateTimeField.Create(Self);
  RecebimentosDatasetalteracao := TDateTimeField.Create(Self);
  RecebimentosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  RecebimentosDataset.BeforeLoadDFMValues;
  RecebimentosDatasetid.BeforeLoadDFMValues;
  RecebimentosDatasetaliado_id.BeforeLoadDFMValues;
  RecebimentosDatasetdata_base_id.BeforeLoadDFMValues;
  RecebimentosDatasetareceber_id.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_bruto_recebido.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_desconto.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_multa.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_juros.BeforeLoadDFMValues;
  RecebimentosDatasetvalor_outros.BeforeLoadDFMValues;
  RecebimentosDatasetdata_recebimento.BeforeLoadDFMValues;
  RecebimentosDatasetplano_contas_id.BeforeLoadDFMValues;
  RecebimentosDatasetconta_id.BeforeLoadDFMValues;
  RecebimentosDatasetmodalidade_id.BeforeLoadDFMValues;
  RecebimentosDatasetfuncionario_id.BeforeLoadDFMValues;
  RecebimentosDatasettitulo_cobranca_id.BeforeLoadDFMValues;
  RecebimentosDatasetrecebimento_via_banco.BeforeLoadDFMValues;
  RecebimentosDatasetrecebimento_venda_aprazo.BeforeLoadDFMValues;
  RecebimentosDatasetcodigo_interno.BeforeLoadDFMValues;
  RecebimentosDatasetexcluido.BeforeLoadDFMValues;
  RecebimentosDatasetinclusao.BeforeLoadDFMValues;
  RecebimentosDatasetalteracao.BeforeLoadDFMValues;
  RecebimentosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewRecebimentosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'areceber_id';
      Title := 'areceber_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_bruto_recebido';
      Title := 'valor_bruto_recebido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'valor_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_multa';
      Title := 'valor_multa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_juros';
      Title := 'valor_juros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_outros';
      Title := 'valor_outros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_recebimento';
      Title := 'data_recebimento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_id';
      Title := 'plano_contas_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_id';
      Title := 'conta_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_id';
      Title := 'modalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'titulo_cobranca_id';
      Title := 'titulo_cobranca_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'recebimento_via_banco';
      Title := 'recebimento_via_banco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'recebimento_venda_aprazo';
      Title := 'recebimento_venda_aprazo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    RecebimentosDataset.SetParentComponent(Self);
    RecebimentosDataset.Name := 'RecebimentosDataset';
    RecebimentosDataset.EntitySetName := 'Recebimentos';
    RecebimentosDataset.Connection := DMConnection.ApiConnection;
    RecebimentosDataset.Left := 72;
    RecebimentosDataset.Top := 144;
    RecebimentosDatasetid.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetid.Name := 'RecebimentosDatasetid';
    RecebimentosDatasetid.FieldName := 'id';
    RecebimentosDatasetid.Required := True;
    RecebimentosDatasetaliado_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetaliado_id.Name := 'RecebimentosDatasetaliado_id';
    RecebimentosDatasetaliado_id.FieldName := 'aliado_id';
    RecebimentosDatasetaliado_id.Required := True;
    RecebimentosDatasetdata_base_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetdata_base_id.Name := 'RecebimentosDatasetdata_base_id';
    RecebimentosDatasetdata_base_id.FieldName := 'data_base_id';
    RecebimentosDatasetdata_base_id.Required := True;
    RecebimentosDatasetareceber_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetareceber_id.Name := 'RecebimentosDatasetareceber_id';
    RecebimentosDatasetareceber_id.FieldName := 'areceber_id';
    RecebimentosDatasetareceber_id.Required := True;
    RecebimentosDatasetvalor_bruto_recebido.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_bruto_recebido.Name := 'RecebimentosDatasetvalor_bruto_recebido';
    RecebimentosDatasetvalor_bruto_recebido.FieldName := 'valor_bruto_recebido';
    RecebimentosDatasetvalor_desconto.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_desconto.Name := 'RecebimentosDatasetvalor_desconto';
    RecebimentosDatasetvalor_desconto.FieldName := 'valor_desconto';
    RecebimentosDatasetvalor_multa.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_multa.Name := 'RecebimentosDatasetvalor_multa';
    RecebimentosDatasetvalor_multa.FieldName := 'valor_multa';
    RecebimentosDatasetvalor_juros.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_juros.Name := 'RecebimentosDatasetvalor_juros';
    RecebimentosDatasetvalor_juros.FieldName := 'valor_juros';
    RecebimentosDatasetvalor_outros.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetvalor_outros.Name := 'RecebimentosDatasetvalor_outros';
    RecebimentosDatasetvalor_outros.FieldName := 'valor_outros';
    RecebimentosDatasetdata_recebimento.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetdata_recebimento.Name := 'RecebimentosDatasetdata_recebimento';
    RecebimentosDatasetdata_recebimento.FieldName := 'data_recebimento';
    RecebimentosDatasetplano_contas_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetplano_contas_id.Name := 'RecebimentosDatasetplano_contas_id';
    RecebimentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    RecebimentosDatasetconta_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetconta_id.Name := 'RecebimentosDatasetconta_id';
    RecebimentosDatasetconta_id.FieldName := 'conta_id';
    RecebimentosDatasetmodalidade_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetmodalidade_id.Name := 'RecebimentosDatasetmodalidade_id';
    RecebimentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    RecebimentosDatasetfuncionario_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetfuncionario_id.Name := 'RecebimentosDatasetfuncionario_id';
    RecebimentosDatasetfuncionario_id.FieldName := 'funcionario_id';
    RecebimentosDatasettitulo_cobranca_id.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasettitulo_cobranca_id.Name := 'RecebimentosDatasettitulo_cobranca_id';
    RecebimentosDatasettitulo_cobranca_id.FieldName := 'titulo_cobranca_id';
    RecebimentosDatasetrecebimento_via_banco.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetrecebimento_via_banco.Name := 'RecebimentosDatasetrecebimento_via_banco';
    RecebimentosDatasetrecebimento_via_banco.FieldName := 'recebimento_via_banco';
    RecebimentosDatasetrecebimento_via_banco.Required := True;
    RecebimentosDatasetrecebimento_venda_aprazo.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetrecebimento_venda_aprazo.Name := 'RecebimentosDatasetrecebimento_venda_aprazo';
    RecebimentosDatasetrecebimento_venda_aprazo.FieldName := 'recebimento_venda_aprazo';
    RecebimentosDatasetrecebimento_venda_aprazo.Required := True;
    RecebimentosDatasetcodigo_interno.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetcodigo_interno.Name := 'RecebimentosDatasetcodigo_interno';
    RecebimentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    RecebimentosDatasetcodigo_interno.Required := True;
    RecebimentosDatasetexcluido.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetexcluido.Name := 'RecebimentosDatasetexcluido';
    RecebimentosDatasetexcluido.FieldName := 'excluido';
    RecebimentosDatasetinclusao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetinclusao.Name := 'RecebimentosDatasetinclusao';
    RecebimentosDatasetinclusao.FieldName := 'inclusao';
    RecebimentosDatasetalteracao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetalteracao.Name := 'RecebimentosDatasetalteracao';
    RecebimentosDatasetalteracao.FieldName := 'alteracao';
    RecebimentosDatasetexclusao.SetParentComponent(RecebimentosDataset);
    RecebimentosDatasetexclusao.Name := 'RecebimentosDatasetexclusao';
    RecebimentosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := RecebimentosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    RecebimentosDataset.AfterLoadDFMValues;
    RecebimentosDatasetid.AfterLoadDFMValues;
    RecebimentosDatasetaliado_id.AfterLoadDFMValues;
    RecebimentosDatasetdata_base_id.AfterLoadDFMValues;
    RecebimentosDatasetareceber_id.AfterLoadDFMValues;
    RecebimentosDatasetvalor_bruto_recebido.AfterLoadDFMValues;
    RecebimentosDatasetvalor_desconto.AfterLoadDFMValues;
    RecebimentosDatasetvalor_multa.AfterLoadDFMValues;
    RecebimentosDatasetvalor_juros.AfterLoadDFMValues;
    RecebimentosDatasetvalor_outros.AfterLoadDFMValues;
    RecebimentosDatasetdata_recebimento.AfterLoadDFMValues;
    RecebimentosDatasetplano_contas_id.AfterLoadDFMValues;
    RecebimentosDatasetconta_id.AfterLoadDFMValues;
    RecebimentosDatasetmodalidade_id.AfterLoadDFMValues;
    RecebimentosDatasetfuncionario_id.AfterLoadDFMValues;
    RecebimentosDatasettitulo_cobranca_id.AfterLoadDFMValues;
    RecebimentosDatasetrecebimento_via_banco.AfterLoadDFMValues;
    RecebimentosDatasetrecebimento_venda_aprazo.AfterLoadDFMValues;
    RecebimentosDatasetcodigo_interno.AfterLoadDFMValues;
    RecebimentosDatasetexcluido.AfterLoadDFMValues;
    RecebimentosDatasetinclusao.AfterLoadDFMValues;
    RecebimentosDatasetalteracao.AfterLoadDFMValues;
    RecebimentosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
